import { FC, ReactElement } from 'react'
import styles from './table.less'

interface IProps {
	head: ReactElement
	body: ReactElement
}

const Table: FC<IProps> = ({ head, body }) => {
	return (
		<table className={styles.table}>
			<thead>{head}</thead>
			<tbody>{body}</tbody>
		</table>
	)
}

export default Table
